<template>
  <div class="search-customer-booking">
    <div class="search-box mb-3" v-if="!searchValue">
      <div class="head mb-2">ค้นหาบุ๊คกิ้ง</div>
      <div class="detail mb-1">กรอกหมายเลขการจอง, เบอร์โทร, อีเมลล์</div>
      <div class="detail mb-3">เพื่อค้นหาบุ๊กกิ้งของท่าน</div>
      <el-input
        type="text"
        class="search mb-4"
        v-model="searchQuery"
      ></el-input>
      <div>
        <sc-button
          variant="orange-cc"
          class="search-button"
          @click="handleSearch"
          >ค้นหา</sc-button
        >
      </div>
    </div>
    <div v-else class="customer-list">
			<booking-customer-list :value="searchValue"></booking-customer-list>
		</div>
  </div>
</template>

<script>
import { Input } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import BookingCustomerList from './BookingCustomerList.vue';

export default {
  components: {
    "el-input": Input,
    "sc-button": ScButton,
    BookingCustomerList,
  },
  data() {
    return {
      searchQuery: null,
      searchValue: null,
    };
  },
  methods: {
    async handleSearch() {
      if (!this.searchQuery) return;

      this.searchValue = this.searchQuery;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables.scss";

.search-customer-booking {
  text-align: left;
}

.head {
  color: $color-orange;
  font-size: $font-30;
}

.search {
  padding: 0;
  width: 500px;
}

.search-button {
  width: 200px;
}

@media screen and (max-width: $m-size) {
  .search {
    padding: 0;
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/other-web/Conference/components/SearchCustomerBooking.vue